import src from "IMAGE";
export default { src, width: 4201, height: 2099, blurWidth: 0, blurHeight: 0};
